import {useSearchParams} from 'react-router-dom';
import {CompetitorAnalysisPanel} from './competitor-analysis-panel';
import {sharedRange} from './competitors-summary-page';
import {useProductPageContext} from './product-context';
import {readCompetitorIds, writeCompetitorIds} from './product-search';

export function CompetitorsComparisonPage() {
	const state = useProductPageContext();
	const [searchParams, setSearchParams] = useSearchParams();
	return (
		<CompetitorAnalysisPanel
			offerId={state.offerId}
			view="comparison"
			sharedPeriod={sharedRange(state)}
			focusIds={readCompetitorIds(searchParams)}
			onFocusIdsChange={(ids) => {
				setSearchParams((prev) => writeCompetitorIds(prev, ids), {replace: true});
			}}
		/>
	);
}
